/**
 * Fitment-Konfigurator (Marke -> Modell -> Karosserie/Baujahr -> Motorisierung
 * -> passende Felgen). Spricht ausschliesslich mit dem eigenen wawi-Backend
 * (/api/fitment/*), niemals direkt mit wheel-size.com — der Server versteckt
 * den API-Key und cached die Katalog-Aufrufe (siehe apps/api/src/fitment im
 * wawi-Repo).
 *
 * Der Generation-Schritt (Karosserie & Baujahr) existiert bewusst als eigener
 * Schritt statt eines geratenen Baujahrs: wheel-size.com verlangt ein Baujahr
 * fuer /modifications/, und ein geratener Wert ("aktuelles Jahr - 3") liefert
 * bei Fahrzeugen ausserhalb dieses Fensters (z. B. Ford F-150, viele
 * Generationen seit 1987) leere Ergebnisse — das echte Baujahr aus der
 * gewaehlten Generation vermeidet das systematisch.
 */
(function () {
  "use strict";

  // Das Script wird oft von mehr als einer Section geladen (Header-Modal +
  // z. B. Slideshow-Hero-Overlay auf derselben Seite). Jedes <script src>-Tag
  // fuehrt diese IIFE erneut aus — ohne dieses Gate wuerde initFitmentCompact()
  // pro Element mehrfach laufen (doppelte Requests, doppelte Listener).
  if (window.__zrFitmentLoaded) return;
  window.__zrFitmentLoaded = true;

  var WZ_CHEVRON_SVG =
    '<svg class="zr-fitment__wz-row-chevron" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M5 3l4 4-4 4" stroke="#6f6f6f" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var WZ_CLOSE_SVG =
    '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  /**
   * Kompakte Variante fuer das Hero-Overlay im Startseiten-Slider — Wizard mit
   * EINEM sichtbaren Feld pro Schritt (Marke -> Modell -> Karosserie & Baujahr
   * -> Motorisierung), Fortschrittsbalken und Chip-Trail fuer bereits
   * getroffene Auswahl, nach Designvorschlag (Felgenpicker-standalone.html).
   * Ersetzt die fruehere Variante mit vier gleichzeitig sichtbaren Feldern.
   */
  function initFitmentCompact(root) {
    var apiBase = root.dataset.apiBase.replace(/\/$/, "");
    var picker = root.querySelector("[data-fit-picker]");
    var stepCountEl = picker.querySelector("[data-fit-step-count]");
    var progressEl = picker.querySelector("[data-fit-progress]");
    var progressSegs = progressEl ? Array.prototype.slice.call(progressEl.children) : [];
    var chipTrailEl = picker.querySelector("[data-fit-chip-trail]");
    var questionEl = picker.querySelector("[data-fit-question]");
    var subtextEl = picker.querySelector("[data-fit-subtext]");
    var fieldWrapEl = picker.querySelector("[data-fit-field-wrap]");
    var fieldLabelEl = picker.querySelector("[data-fit-field-label]");
    var hitsEl = picker.querySelector("[data-fit-hits]");
    var input = picker.querySelector("[data-fit-search]");
    var list = picker.querySelector("[data-fit-wz-list]");
    var quickEl = picker.querySelector("[data-fit-quick]");
    var backEl = picker.querySelector("[data-fit-back]");
    var statusEl = picker.querySelector("[data-fit-status]");
    var resumeEl = picker.querySelector("[data-fit-resume]");
    var resumeVehicleEl = picker.querySelector("[data-fit-resume-vehicle]");
    var resumeContinueEl = picker.querySelector("[data-fit-resume-continue]");
    var resumeResetEl = picker.querySelector("[data-fit-resume-reset]");

    // searchable: Feld mit Tippen-zum-Filtern (Marke/Modell — grosse Listen).
    // Karosserie & Baujahr / Motorisierung haben meist nur eine Handvoll
    // Optionen und zeigen direkt die Liste ohne Suchfeld (wie im
    // Designvorschlag Felgenpicker-Klickdummy.html).
    // Schritt 1/2 haben im Designvorschlag KEINEN Hint-Text unter der Frage
    // (nur Schritt 3/4) — vorher hatte ich hier faelschlich einen Satz aus
    // dem ANDEREN Mockup (Felgenpicker-standalone.html) uebernommen.
    var STEPS = [
      {
        key: "make",
        question: "Welche Marke fährst du?",
        hint: "",
        placeholder: "Marke suchen oder wählen …",
        searchable: true,
        fieldLabel: "Marke",
        showHits: true,
      },
      {
        key: "model",
        question: "Welches Modell?",
        hint: "",
        placeholder: "Modell suchen …",
        searchable: true,
        fieldLabel: null,
        showHits: false,
      },
      {
        key: "gen",
        question: "Karosserie & Baujahr",
        hint: "Steht als Typ im Fahrzeugschein, Feld 2.2 — oder am Baujahr erkennbar.",
        searchable: false,
      },
      {
        key: "mod",
        question: "Welcher Motor?",
        hint: "Entscheidet über Lochkreis und Nabenbohrung.",
        searchable: false,
      },
    ];
    // Slugs geprueft gegen /api/fitment/makes — Mercedes-Benz heisst dort "mercedes".
    var QUICK_MAKES = [
      { value: "volkswagen", label: "VW" },
      { value: "audi", label: "Audi" },
      { value: "bmw", label: "BMW" },
      { value: "mercedes", label: "Mercedes" },
      { value: "ford", label: "Ford" },
    ];

    var state = {
      stepIndex: 0,
      selections: { make: null, model: null, gen: null, mod: null },
      year: null,
    };
    var items = [];
    var matches = [];

    function api(path, params) {
      var url = new URL(apiBase + path);
      Object.keys(params || {}).forEach(function (k) {
        url.searchParams.set(k, params[k]);
      });
      return fetch(url.toString()).then(function (res) {
        if (!res.ok) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              throw new Error(body.message || "Anfrage fehlgeschlagen (" + res.status + ")");
            });
        }
        return res.json();
      });
    }

    function setStatus(text, isWarn) {
      statusEl.textContent = text || "";
      statusEl.classList.toggle("is-warn", !!isWarn);
    }

    function highlightLabel(el, label, query) {
      el.textContent = "";
      var q = (query || "").trim();
      var idx = q ? label.toLowerCase().indexOf(q.toLowerCase()) : -1;
      if (idx === -1) {
        el.appendChild(document.createTextNode(label));
        return;
      }
      el.appendChild(document.createTextNode(label.slice(0, idx)));
      var mark = document.createElement("mark");
      mark.textContent = label.slice(idx, idx + q.length);
      el.appendChild(mark);
      el.appendChild(document.createTextNode(label.slice(idx + q.length)));
    }

    function renderList(filterText) {
      var step = STEPS[state.stepIndex];
      var q = step.searchable ? (filterText || "").trim().toLowerCase() : "";
      matches = q ? items.filter(function (it) { return it.label.toLowerCase().indexOf(q) !== -1; }) : items;
      list.innerHTML = "";
      if (!matches.length) {
        var empty = document.createElement("div");
        empty.className = "zr-fitment__wz-empty";
        empty.textContent = "Keine Treffer";
        list.appendChild(empty);
      } else {
        matches.slice(0, 60).forEach(function (it) {
          var row = document.createElement("button");
          row.type = "button";
          row.className = "zr-fitment__wz-row";
          var main = document.createElement("span");
          main.className = "zr-fitment__wz-row-main";
          var labelEl = document.createElement("span");
          labelEl.className = "zr-fitment__wz-row-label";
          highlightLabel(labelEl, it.label, q);
          main.appendChild(labelEl);
          if (it.sub) {
            var subEl = document.createElement("span");
            subEl.className = "zr-fitment__wz-row-sub";
            subEl.textContent = it.sub;
            main.appendChild(subEl);
          }
          row.appendChild(main);
          row.insertAdjacentHTML("beforeend", WZ_CHEVRON_SVG);
          row.addEventListener("click", function () {
            select(it);
          });
          list.appendChild(row);
        });
        if (step.searchable && matches.length > 8) {
          var footer = document.createElement("div");
          footer.className = "zr-fitment__wz-footer";
          footer.textContent = "Weitertippen für weniger Treffer";
          list.appendChild(footer);
        }
      }
      if (step.showHits) {
        hitsEl.hidden = false;
        hitsEl.textContent = matches.length + " Treffer";
      }
      // Die Liste ist im Designvorschlag (Felgenpicker-Klickdummy.html)
      // PERMANENT sichtbar, sobald die Daten geladen sind — kein Aufklapp-
      // Verhalten bei Fokus/Klick. Bei durchsuchbaren Schritten filtert das
      // Tippen die bereits offene Liste live, statt sie erst zu oeffnen.
      list.hidden = false;
    }

    function select(it) {
      var step = STEPS[state.stepIndex];
      state.selections[step.key] = it;
      if (step.key === "mod") {
        doLookup(it);
      } else {
        goToStep(state.stepIndex + 1);
      }
    }

    function renderChipTrail() {
      chipTrailEl.innerHTML = "";
      var chips = [];
      for (var i = 0; i < state.stepIndex; i++) {
        var sel = state.selections[STEPS[i].key];
        if (sel) chips.push({ index: i, label: sel.chipLabel || sel.label });
      }
      chipTrailEl.hidden = !chips.length;
      chips.forEach(function (chip) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "zr-fitment__wz-chip";
        var span = document.createElement("span");
        span.textContent = chip.label;
        b.appendChild(span);
        b.insertAdjacentHTML("beforeend", WZ_CLOSE_SVG);
        b.addEventListener("click", function () {
          jumpToStep(chip.index);
        });
        chipTrailEl.appendChild(b);
      });
    }

    function renderQuickPicks() {
      quickEl.innerHTML = "";
      var label = document.createElement("span");
      label.className = "zr-fitment__wz-quick-label";
      label.textContent = "Häufig gewählt";
      var row = document.createElement("div");
      row.className = "zr-fitment__wz-quick-row";
      QUICK_MAKES.forEach(function (m) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "zr-fitment__wz-pill";
        b.textContent = m.label;
        b.addEventListener("click", function () {
          select({ value: m.value, label: m.label });
        });
        row.appendChild(b);
      });
      quickEl.appendChild(label);
      quickEl.appendChild(row);
    }

    function enableInput(placeholder) {
      input.disabled = false;
      input.placeholder = placeholder;
      renderList(input.value);
    }

    function loadStepItems(key) {
      if (key === "make") {
        api("/api/fitment/makes", {})
          .then(function (makes) {
            items = makes.map(function (m) {
              return { value: m.slug, label: m.name };
            });
            enableInput(STEPS[0].placeholder);
          })
          .catch(function (err) {
            setStatus(err.message, true);
          });
        return;
      }
      if (key === "model") {
        api("/api/fitment/models", { make: state.selections.make.value })
          .then(function (models) {
            items = models.map(function (m) {
              return { value: m.slug, label: m.name };
            });
            enableInput(STEPS[1].placeholder);
          })
          .catch(function (err) {
            setStatus(err.message, true);
          });
        return;
      }
      if (key === "gen") {
        api("/api/fitment/generations", { make: state.selections.make.value, model: state.selections.model.value })
          .then(function (gens) {
            var sorted = gens.slice().sort(function (a, b) {
              return b.start - a.start;
            });
            items = sorted.map(function (g) {
              var years = g.start + "–" + (g.end || "heute");
              return { value: g.slug, label: g.name, sub: years, chipLabel: g.name + " · " + years, ref: g };
            });
            renderList();
          })
          .catch(function (err) {
            setStatus(err.message, true);
          });
        return;
      }
      if (key === "mod") {
        var gen = state.selections.gen.ref;
        var make = state.selections.make;
        var model = state.selections.model;

        function fetchMods(year) {
          return api("/api/fitment/modifications", { make: make.value, model: model.value, year: year }).then(
            function (allMods) {
              return allMods.filter(function (m) {
                return m.generation.slug === gen.slug;
              });
            }
          );
        }

        var primaryYear = gen.end || gen.start;
        // Uebergangsjahre zwischen zwei Generationen ordnet wheel-size.com
        // manchmal komplett der jeweils ANDEREN Generation zu — primaryYear
        // liefert dann 0 Treffer, obwohl die Generation echte Motorisierungen
        // hat. Einmaliger Fallback aufs andere Randjahr, bevor wir "keine
        // Motorisierungen gefunden" zeigen.
        var altYear = gen.end && gen.start !== gen.end ? gen.start : null;

        fetchMods(primaryYear)
          .then(function (mods) {
            if (mods.length || !altYear) return { mods: mods, year: primaryYear };
            return fetchMods(altYear).then(function (fallbackMods) {
              return { mods: fallbackMods, year: altYear };
            });
          })
          .then(function (result) {
            state.year = result.year;
            items = result.mods.map(function (m) {
              var years = m.startYear && m.endYear ? m.startYear + "–" + m.endYear : "";
              return { value: m.slug, label: m.trim || m.generation.name, sub: years };
            });
            renderList();
          })
          .catch(function (err) {
            setStatus(err.message, true);
          });
        return;
      }
    }

    function goToStep(i) {
      state.stepIndex = i;
      var step = STEPS[i];
      setStatus("");

      stepCountEl.textContent = "Schritt " + (i + 1) + " von " + STEPS.length;
      progressSegs.forEach(function (seg, idx) {
        seg.classList.toggle("is-filled", idx <= i);
      });
      questionEl.textContent = step.question;
      subtextEl.textContent = step.hint;
      subtextEl.hidden = !step.hint;

      renderChipTrail();

      quickEl.hidden = i !== 0;
      if (i === 0) renderQuickPicks();

      backEl.hidden = i === 0;

      // Marke/Modell: durchsuchbares Feld. Karosserie & Baujahr/Motorisierung:
      // kein Feld — bei einer Handvoll Optionen zeigt die Liste sich direkt
      // (siehe Felgenpicker-Klickdummy.html).
      fieldWrapEl.hidden = !step.searchable;
      fieldLabelEl.hidden = !step.fieldLabel;
      fieldLabelEl.textContent = step.fieldLabel || "";
      hitsEl.hidden = true;

      items = [];
      list.hidden = true;
      list.innerHTML = "";
      input.value = "";
      input.disabled = true;
      input.placeholder = "Lädt …";

      loadStepItems(step.key);
    }

    function jumpToStep(i) {
      for (var k = i; k < STEPS.length; k++) {
        state.selections[STEPS[k].key] = null;
      }
      goToStep(i);
    }

    function doLookup(mod) {
      setStatus("Passende Felgen werden gesucht …");
      input.disabled = true;
      input.placeholder = "Sucht …";
      api("/api/fitment/lookup", {
        make: state.selections.make.value,
        model: state.selections.model.value,
        year: state.year,
        modification: mod.value,
      })
        .then(function (fit) {
          if (fit && fit.collection) {
            // Fuer die "Dein Fahrzeug"-OE-Box auf der Zielkollektion (siehe
            // snippets/zr-fitment-oe.liquid) — Shopify-Liquid kann keine
            // beliebigen URL-Parameter lesen, daher sessionStorage statt
            // Query-String. Nur fuer die aktuelle Sitzung (kein localStorage),
            // reines Echo der ohnehin schon abgerufenen Werte fuer denselben
            // Nutzer, kein serverseitiges Caching — TOS-unkritisch.
            try {
              sessionStorage.setItem(
                "zr_fitment",
                JSON.stringify({
                  // Erhoehen, wenn sich die stockWheels-Form nochmal aendert
                  // (siehe zr-fitment-oe.js/zr-fitment-et.js) — sonst rendern
                  // Tabs mit einem AELTEREN sessionStorage-Eintrag (Kunde hat
                  // das Fahrzeug vor einem Deploy gewaehlt) eine Box mit leerer
                  // "Werksbereifung ab Werk"-Liste statt gar nicht zu rendern.
                  schemaVersion: 2,
                  vehicle: [
                    state.selections.make.label,
                    state.selections.model.label,
                    state.selections.gen ? state.selections.gen.label : null,
                    mod.label,
                  ]
                    .filter(Boolean)
                    .join(" · "),
                  boltPattern: fit.boltPattern,
                  rearBoltPattern: fit.rearBoltPattern,
                  centreBoreMm: fit.centreBoreMm,
                  threadSize: fit.threadSize,
                  tighteningTorque: fit.tighteningTorque,
                  enginePowerPs: fit.enginePowerPs,
                  stockWheels: fit.stockWheels,
                  collectionSlug: fit.collection.slug,
                  collectionUrl: "/collections/" + fit.collection.slug,
                })
              );
            } catch (e) {
              // Privater Modus / Speicher voll etc. — die OE-Box ist ein
              // Komfort-Feature, kein kritischer Pfad. Einfach weiterleiten.
            }
            // Relativer Pfad statt fit.collection.url (das Backend liefert dort
            // fest https://www.zrshop.de/... — kennt die aufrufende Domain
            // nicht). So bleibt der Redirect immer auf der Domain, auf der der
            // Picker gerade laeuft: lokale Vorschau beim Testen bleibt lokal,
            // produktiv bleibt produktiv. Ohne das landet man beim lokalen
            // Testen auf der echten Live-Seite und sieht z. B. die
            // "Dein Fahrzeug"-Box (die nur lokal existiert) gar nicht.
            window.location.href = "/collections/" + fit.collection.slug;
            return;
          }
          setStatus(
            fit
              ? "Für diesen Lochkreis führen wir aktuell keine Kollektion."
              : "Keine Fitment-Daten für dieses Fahrzeug gefunden.",
            true
          );
        })
        .catch(function (err) {
          setStatus(err.message, true);
        });
    }

    input.addEventListener("input", function () {
      renderList(input.value);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        if (matches.length) select(matches[0]);
      }
    });

    backEl.addEventListener("click", function (e) {
      e.preventDefault();
      if (state.stepIndex > 0) jumpToStep(state.stepIndex - 1);
    });

    // Wizard immer normal initialisieren (laedt z. B. schon die Markenliste
    // vor) — die Resume-Ansicht liegt nur als Overlay darueber, damit "Neues
    // Fahrzeug waehlen" sofort nutzbar ist statt erst nachzuladen.
    function tryShowResume() {
      var raw;
      try {
        raw = sessionStorage.getItem("zr_fitment");
      } catch (e) {
        return;
      }
      if (!raw) return;
      var data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        return;
      }
      if (!data || !data.vehicle || !data.collectionUrl) return;
      resumeVehicleEl.textContent = data.vehicle;
      resumeContinueEl.href = data.collectionUrl;
      resumeEl.hidden = false;
      picker.classList.add("is-resuming");
    }

    resumeResetEl.addEventListener("click", function () {
      picker.classList.remove("is-resuming");
      resumeEl.hidden = true;
    });

    goToStep(0);
    tryShowResume();
  }

  // Instanzen mit data-fit-lazy (z. B. im Header-Modal) starten NICHT beim
  // Seitenaufruf, sonst würde jede Page-View einen wheel-size.com-Aufruf
  // auslösen, obwohl der Konfigurator nie geöffnet wird. Der Aufrufer
  // (zr-header.js) ruft window.ZrFitmentInit(el) einmalig beim ersten Öffnen.
  //
  // initialised ist zusaetzlich das Schutz-Gate gegen Doppel-Ausfuehrung: das
  // Script wird oft von mehr als einer Section geladen (Header + z. B.
  // Slideshow-Hero-Overlay auf derselben Seite) — jedes <script src>-Tag
  // fuehrt die IIFE erneut aus, sonst wuerde initFitmentCompact() pro Element
  // mehrfach laufen (doppelte Requests, doppelte Listener).
  var initialised = new WeakSet();
  function initAny(el) {
    if (initialised.has(el)) return;
    initialised.add(el);
    initFitmentCompact(el);
  }
  window.ZrFitmentInit = initAny;

  document.querySelectorAll("[data-fitment-configurator]:not([data-fit-lazy])").forEach(initAny);
})();
